/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Sync_Desc4Inputs */

const en_svc_automation_sync_desc4 = /** @type {(inputs: Svc_Automation_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automate across the tools you already use, CRMs, spreadsheets, databases, and SaaS, replacing Monday-morning copy-paste marathons.`)
};

const ar_svc_automation_sync_desc4 = /** @type {(inputs: Svc_Automation_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أتمتة عبر الأدوات التي تستخدمها فعلًا, أنظمة علاقات العملاء وجداول البيانات وقواعد البيانات وSaaS, لتنهي ماراثونات النسخ واللصق.`)
};

const bn_svc_automation_sync_desc4 = /** @type {(inputs: Svc_Automation_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি যে টুলগুলো ইতিমধ্যে ব্যবহার করেন সেগুলো জুড়ে অটোমেট করুন, CRM, স্প্রেডশিট, ডেটাবেস ও SaaS, সোমবার সকালের কপি-পেস্ট ম্যারাথন বাদ দিন।`)
};

const de_svc_automation_sync_desc4 = /** @type {(inputs: Svc_Automation_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisieren Sie alle Tools, die Sie bereits verwenden, CRMs, Tabellenkalkulationen, Datenbanken und SaaS, und ersetzen Sie so den Kopier-Einfüge-Marathon am Montagmorgen.`)
};

const es_svc_automation_sync_desc4 = /** @type {(inputs: Svc_Automation_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatice las herramientas que ya utiliza, CRM, hojas de cálculo, bases de datos y SaaS, reemplazando los maratones de copiar y pegar los lunes por la mañana.`)
};

const fr_svc_automation_sync_desc4 = /** @type {(inputs: Svc_Automation_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisez les outils que vous utilisez déjà, les CRM, les feuilles de calcul, les bases de données et les SaaS, en remplaçant les marathons de copier-coller du lundi matin.`)
};

const pt_svc_automation_sync_desc4 = /** @type {(inputs: Svc_Automation_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatize as ferramentas que você já usa, CRMs, planilhas, bancos de dados e SaaS, substituindo as maratonas de copiar e colar nas manhãs de segunda-feira.`)
};

const zh_svc_automation_sync_desc4 = /** @type {(inputs: Svc_Automation_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对您已使用的工具、CRM、电子表格、数据库和 SaaS 进行自动化，取代周一早上的复制粘贴马拉松。`)
};

const tr_svc_automation_sync_desc4 = /** @type {(inputs: Svc_Automation_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazartesi sabahı kopyala-yapıştır maratonları yerine, zaten kullandığınız CRM'leri, tabloları, veritabanlarını ve SaaS araçlarını otomatikleştirin.`)
};

const ru_svc_automation_sync_desc4 = /** @type {(inputs: Svc_Automation_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматизируйте все инструменты, которые вы уже используете: CRM, электронные таблицы, базы данных и SaaS, заменив марафоны копирования и вставки по утрам понедельника.`)
};

const pl_svc_automation_sync_desc4 = /** @type {(inputs: Svc_Automation_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zautomatyzuj narzędzia, których już używasz, CRM, arkusze kalkulacyjne, bazy danych i SaaS, zastępując poniedziałkowe poranne maratony kopiowania i wklejania.`)
};

/**
* | output |
* | --- |
* | "Automate across the tools you already use, CRMs, spreadsheets, databases, and SaaS, replacing Monday-morning copy-paste marathons." |
*
* @param {Svc_Automation_Sync_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_sync_desc4 = /** @type {((inputs?: Svc_Automation_Sync_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Sync_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_sync_desc4(inputs)
	if (locale === "bn") return bn_svc_automation_sync_desc4(inputs)
	if (locale === "de") return de_svc_automation_sync_desc4(inputs)
	if (locale === "es") return es_svc_automation_sync_desc4(inputs)
	if (locale === "fr") return fr_svc_automation_sync_desc4(inputs)
	if (locale === "pt") return pt_svc_automation_sync_desc4(inputs)
	if (locale === "zh") return zh_svc_automation_sync_desc4(inputs)
	if (locale === "tr") return tr_svc_automation_sync_desc4(inputs)
	if (locale === "ru") return ru_svc_automation_sync_desc4(inputs)
	if (locale === "pl") return pl_svc_automation_sync_desc4(inputs)
	return en_svc_automation_sync_desc4(inputs)
});
export { svc_automation_sync_desc4 as "svc_automation_SYNC_desc" }